<template>
  <div class="page__wrapper" @scroll="onScroll()">
    <img src="@/assets/infographics/attendance-1.svg" />
    <img src="@/assets/infographics/attendance-2.svg" />
    <img src="@/assets/infographics/attendance-3.svg" />
  </div>
</template>

<script>
export default {
  mounted() {
    const ref = this.$store.state.menu.ourFans.ref;
    const index = this.$store.state.menu.menuItems.map(e => e.ref).indexOf(ref);
    this.$store.state.menu.activeSection = index;
    this.$store.state.menu.currentSectionTitle = this.$store.state.menu.ourFans.title;
    this.$store.state.menu.currentSectionNavigation = this.$store.state.menu.ourFans.nav;
    this.onScroll();
  },
  data() {
    return {
      h2: "Our Fans",
      h3: "Attendance"
    };
  }
};
</script>

<style lang="scss" scoped>
.page__wrapper {
  &::after {
    background-image: linear-gradient(90deg, #07173a 0%, #030a18 100%);
    position: absolute;
    right: 0;
    top: 0;
    width: 100%;
    min-height: 100%;
    pointer-events: none;
    content: " ";
  }
  background-image: url("~@/assets/backgrounds/bg-attendance.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  flex-wrap: wrap;
  padding-top: 0 !important;
  white-space: nowrap;
  img {
    display: inline-block;
    object-fit: contain;
    z-index: 1;
    margin: 15px;
    max-width: calc(100vw - 30px);
  }
  @media (max-width: 1200px) {
    margin-top: 125px;
  }
}
</style>